import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { SoporteIntegranteDTO } from '../../models/soporte-documental/soporte-documental-response';
import { SoporteDocumentalRequest } from '../../models/soporte-documental/soporte-documental-request';

@Injectable({
  providedIn: 'root',
})
export class SoporteDocumentalService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.SOPORTES}`;

  constructor(private http: HttpClient) {}

  consultarDocumentos(
    request: SoporteDocumentalRequest,
  ): Observable<SoporteIntegranteDTO[]> {
    const urlConsultar = `${this.apiUrl}/consultar`;
    return this.http.post<SoporteIntegranteDTO[]>(urlConsultar, request);
  }

  subirArchivo(
    file: File,
    idDocSoporte: number,
    identificacion: string,
  ): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('idDocSoporte', idDocSoporte.toString());
    formData.append('identificacion', identificacion);

    return this.http.post(`${this.apiUrl}/upload`, formData);
  }

  descargarArchivo(idDocSoporte: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/download/${idDocSoporte}`, {
      responseType: 'blob',
    });
  }

  eliminarArchivo(idDocSoporte: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/delete/${idDocSoporte}`);
  }
}
